import Api from "~/service/Api";

class TourVideoRegenerationRepository {
  create(tourId) {
    return Api.post(`/tour/video-regenerations/${tourId}`, {});
  }
}

export default TourVideoRegenerationRepository;
